import { Button, Modal } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Select } from "antd";
import { GroupProps } from "../../interfaces/interfaces";
import { GROUP_INITIAL_STATE } from "../../utils/data";
import DataContext from "../../context/DataContext";
import { filterOption } from "../../utils/func/utils";

interface Props {
  modalStatus: {
    open: boolean;
    create: boolean;
    update: boolean;
    multiple: boolean;
    payload?: GroupProps | null;
  };
  onCancel: () => void;
  onSubmit: (values: GroupProps) => void;
}

export const ModalGroupForm = ({
  modalStatus: { payload, open, create },
  onCancel,
  onSubmit,
}: Props) => {
  const [form] = Form.useForm();
  const { usersList } = useContext(DataContext);
  const [values, setValues] = useState<GroupProps>(GROUP_INITIAL_STATE);
  const onFinish = () => {
    onSubmit(values);
  };

  useEffect(() => {
    if (values) {
      form.setFieldsValue(values);
    } else {
      form.setFieldsValue(GROUP_INITIAL_STATE);
      setValues(GROUP_INITIAL_STATE);
    }
  }, [values]);

  useEffect(() => {
    if (payload) {
      setValues(payload);
    } else {
      setValues(GROUP_INITIAL_STATE);
    }
  }, [payload]);

  return (
    <Modal
      onOk={onCancel}
      onCancel={onCancel}
      footer={null}
      open={open}
      title="Group"
    >
      <Form
        form={form}
        initialValues={values}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please input group name" }]}
        >
          <Input
            value={values?.name}
            onChange={(event) =>
              setValues((prev) => {
                return {
                  ...prev,
                  name: event.target.value,
                };
              })
            }
          />
        </Form.Item>

        <Form.Item label="Users">
          <Select
            mode="multiple"
            placeholder="Select Users"
            filterOption={filterOption}
            showSearch
            options={usersList?.map((user) => ({
              label: user.name,
              value: user._id,
            }))}
            value={values.users?.map((user) => user._id)}
            onChange={(value) => {
              const selected = usersList.filter((user) =>
                value.includes(user._id as any),
              );

              setValues((prev) => ({ ...prev, users: selected }));
            }}
          ></Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};
